import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { GameService } from 'src/app/services/game.service';
import { UtilityService } from 'src/app/services/utility.service';
import { MatchmakingService } from 'src/app/services/matchmaking.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-match-message-alert',
  templateUrl: './match-message-alert.component.html',
  styleUrls: ['./match-message-alert.component.scss']
})
export class MatchMessageAlertComponent implements OnInit {

  @Input() title: string;
  @Input() body: string;

  subStatusMatch: Subscription = new Subscription();

  constructor(
    private modalCtrl: ModalController,
    private router: Router,
    private gameSrv: GameService,
    private utilSrv: UtilityService,
    private matchmSrv: MatchmakingService,
    private _authSrv: AuthenticationService,
  ) {
  }

  ngOnInit() {
  }

  goToRandomMatch() {
    // confirm match and set match id
    this.matchmSrv.confirmRandomMatch(this.utilSrv.difficulty).subscribe(data => {
      console.log('confirmMatch call: ', data);
      this.gameSrv.idGame = data;
      // listens on the user's status
      this.subStatusMatch = this.matchmSrv.statusMatch().subscribe(data => {
        console.log('user status: ', data.payload.data());
        if (data.payload.data().status === 'IN_GAME'){
          this.utilSrv.hideLoading();
          // find nickname of the opponent user and then enter in game
          if(data.payload.data().matchId !== '' || data.payload.data().matchId !== undefined) {
            this._authSrv.getUserByUuid(data.payload.data().opponentId).get().subscribe(ref => {
              this.gameSrv.secondGamer = ref.data().nickname;
              })
            this.onCloseModal();
            this.router.navigate(['home', 'game']);
          }
          // time out
        } else if(data.payload.data().status == 'NOT_ACTIVE') {
          this.utilSrv.hideLoading();
          this.onCloseModal();
          this.utilSrv.presentGenericModal('MI DISPIACE!', 'L\'avversario ha abbandonato la partita.', false);
          this.router.navigate(['home']);
        }
      }, (err) => {
        console.log(err);
        this.utilSrv.hideLoading();
        this.utilSrv.presentGenericModal('ATTENZIONE', err.message, false);
      });
    }, err => {
      console.log(err);
      this.utilSrv.hideLoading();
      this.utilSrv.presentGenericModal('ATTENZIONE', err.message, false);
    });
    this.utilSrv.showLoading();
  }

  goToHomepage() {
    this.matchmSrv.stopMatchmaking(this.utilSrv.difficulty).subscribe(data => {
      console.log('stopMatchmaking call: ', data);
      this.onCloseModal();
      this.router.navigate(['home']);
    }, error => {
      console.log(error);
      this.utilSrv.presentGenericModal('ATTENZIONE', error.message, false);
    });
  }

  onCloseModal(){
    this.modalCtrl.dismiss();
    console.log('unsubscribe user status');
    this.subStatusMatch.unsubscribe();
  }

}
